import * as normalizeUrl from 'normalize-url'
import { match } from 'react-router-dom'
import { UrlWithParsedQuery } from 'url'

import { Site } from '../../constants/siteList'
import { IEnhancedLocation } from '../../reducers/reactRouterLocation'
import { parseLocation } from '../../utils/urlHelper'
import { hasFeature } from '../features'
import { formatSearchLocationParams } from './format'
import { ICommonLocation, ILocationParams, IQuery } from './types'

interface IGetSearchLocationParamsProps {
  location: ICommonLocation
  routeMatch: match<IQuery>
  currentSite: Site
  experiments?: any
}

export const stringUrlsEqual = (a: string, b: string) => {
  if (a === b) {
    return true
  }

  return (
    normalizeUrl(a, { removeTrailingSlash: false }) ===
    normalizeUrl(b, { removeTrailingSlash: false })
  )
}

export const getLocationParams = (
  location: ICommonLocation,
  routeMatch: match<IQuery>
): IQuery => ({
  ...location.query,
  ...routeMatch.params
})

export const getSearchLocationParams = ({
  location,
  routeMatch,
  currentSite,
  experiments
}: IGetSearchLocationParamsProps): ILocationParams => {
  if (hasFeature('routes:new', currentSite, location, experiments)) {
    return formatSearchLocationParams(getLocationParams(location, routeMatch))
  }

  return parseLocation({
    pathname: location.pathname || '/',
    query: location.query
  })
}

export const convertToCommonLocation = (
  location: Partial<ICommonLocation>
): ICommonLocation => ({
  pathname: location.pathname || '/',
  search: location.search || '',
  query: location.query || {},
  hash: location.hash || ''
})
